import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import RadioInput from '@common/radioInput';
import Image from '@common/image';
import Text from '@common/text';
import { NhisProvider } from '@domain/constant/nhis/NHISProviderType';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ProviderProps extends UseControllerProps {}

const Provider = (props: ProviderProps) => {
  const { field } = useController(props);

  return (
    <div className={cx('listArea')}>
      <label className={cx('listItem')}>
        <RadioInput
          {...field}
          name={'provider'}
          label={''}
          value={NhisProvider.KAKAO}
          checked={field.value === NhisProvider.KAKAO}
        />
        <Image
          className={cx('img')}
          src={'/img/v2/components/profile/nhisCareerModal/iconKakao.png'}
          alt={'카카오톡'}
          width={40}
          height={40}
          pointer
        />
        <Text className={cx('text')} fontStyle={FontStyle.B3_M}>
          카카오톡
        </Text>
      </label>
      <label className={cx('listItem')}>
        <RadioInput
          {...field}
          name={'provider'}
          label={''}
          value={NhisProvider.NAVER}
          checked={field.value === NhisProvider.NAVER}
        />
        <Image
          className={cx('img')}
          src={'/img/v2/components/profile/nhisCareerModal/iconNaver.png'}
          alt={'네이버'}
          width={40}
          height={40}
          pointer
        />
        <Text className={cx('text')} fontStyle={FontStyle.B3_M}>
          네이버
        </Text>
      </label>
    </div>
  );
};

export default Provider;
